import { ArquivoModal } from '@components/Modal/ArquvioModal';
import { IModalWindow } from '@hooks/useModalWindow';
import { useRetornoService } from '@services/RetornoService';
import React from 'react';

export type RetornoImportarModalProps = {
    modal: IModalWindow
}

export function RetornoImportarModal ({ modal }: RetornoImportarModalProps) {
    const retornoService = useRetornoService();
    
    return (
        <ArquivoModal
            modal={modal}
            title="Importação de Arquivos de Retorno"
            accept=".ret"
            buttonText="Importar Arquivos de Retorno"
            uploadFunction={retornoService.importar}
        />
    )
}